<template>
    <div class="tile">
        <slot name="content" :orderDetails="orderDetails"></slot>
    </div>
</template>

<script>
    import BADGES_COLOR_MAP from '@/data/badges-color-map';
    import OrderModel from '@/common/models/order-model';

    const summaryDateFormat = 'MMM Do';

    export default {
        name: 'order-summary',
        props: {
            order: Object,
            summary: [Object, String],
        },
        computed: {
            orderDetails() {
                return {
                    order: this.order,
                    summary: this.summary,
                    statusBadges: this.statusBadges,
                    summaryMetrics: this.summaryMetrics,
                    canCancelAndUpdateRenewal: this.canCancelAndUpdateRenewal,
                };
            },
            statusBadges() {
                return [
                    {
                        predicate: true,
                        type: (() => (BADGES_COLOR_MAP.orderStatus[this.order.status]))(),
                        value: this.order.status,
                    },
                    {
                        predicate: this.order.inTrial,
                        type: 'info',
                        value: 'In trial',
                    },
                ].filter(v => v.predicate);
            },
            summaryHasData() {
                return this.summary && Object.keys(this.summary).length > 0;
            },
            canCancelAndUpdateRenewal() {
                return !!(this.order.orderType !== OrderModel.Types.oneTime);
            },
            summaryMetrics() {
                const {endTime, renewalTime} = this.order;

                const result = [
                    {
                        label: 'Invoiced',
                        value: this.summaryHasData ? this.$filters.monetizeExplicit(this.summary.invoicedAmount, this.summary.currency) : 'n/a',
                    },
                    {
                        label: 'Collected',
                        value: this.summaryHasData ? this.$filters.monetizeExplicit(this.summary.collectedAmount, this.summary.currency) : 'n/a',
                    },
                    {
                        label: '# Invoices',
                        value: this.summaryHasData ? this.summary.invoiceCount : 'n/a',
                    },
                ];

                if (endTime) {
                    result.push({
                        label: 'Ended On',
                        value: this.$filters.dateTime(endTime, summaryDateFormat),
                    });
                } else if (renewalTime) {
                    result.push({
                        label: 'Renewal Date',
                        value: this.$filters.dateTime(renewalTime, summaryDateFormat),
                    });
                }
                return result;
            },
        },
    };
</script>

<style scoped>

</style>
